/**
 * KIT category tile — icon above label. Tap navigates to the
 * category detail page. Deliberately not a shopping tile: no price,
 * no image, no "shop now" language.
 */
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { resolveKitCategoryIcon } from "./iconMap";

export function KitCategoryTile({ category, to }) {
    const Icon = resolveKitCategoryIcon(category.icon);
    return (
        <Link
            to={to}
            data-testid={`kit-category-${category.slug}`}
            className="tap group relative rounded-xl border border-white/5 border-l-2 border-l-cyan-400/40 bg-card/40 hover:bg-white/5 p-4 flex flex-col items-start gap-3 min-h-[112px]"
        >
            <span className="h-10 w-10 rounded-lg bg-cyan-400/10 text-cyan-300 flex items-center justify-center">
                <Icon size={18} />
            </span>
            <span className="min-w-0">
                <span className="block text-white font-semibold text-sm leading-tight">
                    {category.name}
                </span>
                {category.description ? (
                    <span className="block text-[11px] text-neutral-400 mt-1 leading-snug">
                        {category.description}
                    </span>
                ) : null}
            </span>
            <ChevronRight
                size={14}
                className="absolute top-4 right-3 text-neutral-500 group-hover:text-neutral-300"
            />
        </Link>
    );
}
